import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { RouteConstants } from '../constants/route-constant';

const ProtectedRoute = ({
  children,
  requiredRole,
}: {
  children: ReactNode;
  requiredRole?: string;
}) => {
  const { isAuthenticated, isLoading, user } = useAuth0();

  if (isLoading) return null;

  if (
    requiredRole &&
    (!user || !(user['https://your-app/roles'] || []).includes(requiredRole))
  ) {
    return <Navigate to={RouteConstants.ROUTE_HOME} />;
  }

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={RouteConstants.ROUTE_LOGIN} />
  );
};

export default ProtectedRoute;
